import * as React from "react";
import { Input, Select, Tag } from "antd";
import { observer } from "mobx-react-lite";
import { Utils } from "../../common/misc/Utils";
import TaskStatusesVisualStore from "../stores/TaskStatusesVisualStore";
import { TaskType } from "../../task_types/types";

type Props = {
    currentTab: string;
    isCustomMode: boolean;
    store: TaskStatusesVisualStore;
    onSearchEnter: (event: React.KeyboardEvent<HTMLInputElement>) => void;
};

const TaskStatusesFilters: React.FC<Props> = ({
    currentTab,
    isCustomMode,
    store,
    onSearchEnter,
}) => {
    const renderTaskTypeLabel = (taskType: TaskType) => (
        <>
            {taskType.name}
            {taskType.isSystemDefault ? (
                <Tag className="alpha-info-tag" style={{ marginLeft: 8 }}>
                    System managed
                </Tag>
            ) : null}
        </>
    );

    return (
        <div className="projects-list-container" style={{ marginBottom: 10 }}>
            <Select
                options={
                    store.projects?.map((project) => ({
                        label: project.name,
                        value: project.id,
                    })) || []
                }
                placeholder="Select project"
                onChange={store.setSelectedProjectId}
                style={{ width: 300, marginRight: 10 }}
                showSearch
                filterOption={Utils.filterOption}
            />
            <Select
                data-id="input-Name"
                value={store.selectedTaskType}
                onChange={store.setSelectedTaskType}
                style={{ width: 300 }}
                placeholder="Select type"
                showSearch
                filterOption={Utils.filterOption}
                options={
                    store.taskTypes
                        ? store.taskTypes.map((taskType) => ({
                              label: renderTaskTypeLabel(taskType),
                              value: taskType.id,
                              customFilterValue: taskType.name,
                          }))
                        : []
                }
            />
            {currentTab === "1" && isCustomMode && (
                <Input
                    data-id="search area"
                    placeholder="Search..."
                    onPressEnter={onSearchEnter}
                    onClear={() => store.setSearchString("")}
                    maxLength={150}
                    style={{ width: 200, marginLeft: "auto" }}
                    prefix={
                        <i
                            className="alpha-icon xs table-search"
                            style={{ marginRight: 10 }}
                        />
                    }
                    allowClear
                />
            )}
        </div>
    );
};

export default observer(TaskStatusesFilters);
